import { render, staticRenderFns } from "./BuildYourJewelSelectedStones.vue?vue&type=template&id=0902e77b&scoped=true&"
import script from "./BuildYourJewelSelectedStones.vue?vue&type=script&lang=js&"
export * from "./BuildYourJewelSelectedStones.vue?vue&type=script&lang=js&"
import style0 from "./BuildYourJewelSelectedStones.vue?vue&type=style&index=0&id=0902e77b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0902e77b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0902e77b')) {
      api.createRecord('0902e77b', component.options)
    } else {
      api.reload('0902e77b', component.options)
    }
    module.hot.accept("./BuildYourJewelSelectedStones.vue?vue&type=template&id=0902e77b&scoped=true&", function () {
      api.rerender('0902e77b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BuildYourJewelSelectedStones.vue"
export default component.exports